import React from 'react';
import { StackView, Heading2 } from 'localmed-core';
import styled from '@emotion/styled';

import DIError from '../../icons/DI/DIError';

export const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export default function DiFailure({ title, children }) {
  return (
    <Wrapper>
      <StackView spacing="md" textAlign="center">
        <DIError />
        <StackView spacing="xs">
          <Heading2 fontWeight="bold">{title}</Heading2>
          {children}
        </StackView>
      </StackView>
    </Wrapper>
  );
}
